import { Tabs as CoreTabs } from '@studiometa/ui';

/**
 * Tabs component
 */
export class Tabs extends CoreTabs {
  /**
   * Enable item
   * @param {object} item
   * @returns {Promise}
   */
  enableItem(item) {
    if (!item || item.isEnabled) {
      return Promise.resolve(this);
    }
    item.btn.classList.add('is-active');
    return super.enableItem(item);
  }

  /**
   * Disable item
   * @param {object} item
   * @returns {Promise}
   */
  disableItem(item) {
    if (!item || !item.isEnabled) {
      return Promise.resolve(this);
    }
    item.btn.classList.remove('is-active');
    return super.disableItem(item);
  }
}
